module.exports = __webpack_public_path__ + "img/mail.26ca1347.svg";